"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import AccountChildEditBindDialog from "./dialog/AccountChildEditBindDialog.vue";
import AccountChildChangeBindDialog from "./dialog/AccountChildChangeBindDialog.vue";
let UserSafe = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.verifiedFlag = "unbind";
    this.phone = "";
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getUserVerifyInfo();
    });
  }
  refresh() {
    return __async(this, null, function* () {
      yield this.getUserVerifyInfo();
    });
  }
  changePhone() {
    this._accountChildChangeBindDialog.open(this.phone);
  }
  bindPhone() {
    this._accountChildEditBindDialog.open("", "bind");
  }
  unbindPhone() {
    this._accountChildEditBindDialog.open(this.phone, "unbind");
  }
  encryptphone(phone) {
    let _phone = phone;
    if (phone !== null) {
      let arr1 = phone.toString().substring(0, 3);
      let arr2 = phone.toString().substring(phone.toString().length - 4, phone.toString().length);
      _phone = arr1 + "****" + arr2;
    }
    return _phone;
  }
  getUserVerifyInfo() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth/api/v1/user/bindphone/info`
        );
        this.verifiedFlag = response.data.status;
        this.phone = response.data.phone;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("account-child-edit-bind-dialog")
], UserSafe.prototype, "_accountChildEditBindDialog", 2);
__decorateClass([
  Ref("account-child-change-bind-dialog")
], UserSafe.prototype, "_accountChildChangeBindDialog", 2);
UserSafe = __decorateClass([
  Component({
    components: {
      AccountChildEditBindDialog,
      AccountChildChangeBindDialog
    }
  })
], UserSafe);
export {
  UserSafe as default
};
